import type { ShopCatalogFilters } from '../types';

export interface NormalisedProductsKey {
  q?: string;
  categoryId?: string;
  inStock?: true;
  minPrice?: number;
  maxPrice?: number;
  sort: ShopCatalogFilters['sort'];
  limit: number;
}

/**
 * Builds the object embedded in the products query key.
 *
 * React Query hashes objects with sorted keys, so property order is irrelevant
 * — but undefined keys must be omitted entirely and prices must be real
 * numbers, otherwise '100' and 100 produce two separate cache entries.
 */
export const normaliseProductsKey = (
  filters: ShopCatalogFilters,
  limit: number
): NormalisedProductsKey => {
  const key: NormalisedProductsKey = { sort: filters.sort, limit };

  if (filters.q) key.q = filters.q;
  if (filters.categoryId) key.categoryId = filters.categoryId;
  if (filters.inStock) key.inStock = true;
  if (typeof filters.minPrice === 'number') key.minPrice = filters.minPrice;
  if (typeof filters.maxPrice === 'number') key.maxPrice = filters.maxPrice;

  return key;
};

export const shopKeys = {
  all: ['shop'] as const,
  settings: ['shop', 'settings'] as const,
  categories: ['shop', 'categories'] as const,
  products: (key: NormalisedProductsKey) => ['shop', 'products', 'list', key] as const,
  product: (slug: string) => ['shop', 'product', slug] as const,
};
